var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SidbearSettingsGroup',{attrs:{"title":"Breadcrumbs","active":""}},[_c('rule-tabs',{attrs:{"tabs":['Normal', 'Hover', 'Active']},scopedSlots:_vm._u([{key:"Normal",fn:function(){return [_c('sid-range-slider',{attrs:{"label":"Font Size","sid":_vm.className(' a'),"rule-name":"font-size"}}),_c('b-form-group',{attrs:{"label":"Link Color"}},[_c('sid-color',{attrs:{"rule-name":"color","allow-reset":"","sid":_vm.className(' a')}})],1),_c('b-form-group',{attrs:{"label":"Icon Color"}},[_c('sid-color',{attrs:{"rule-name":"stroke","allow-reset":"","sid":_vm.className(' path')}})],1),_c('sid-font',{attrs:{"sid":_vm.className(' a')}}),_c('sid-background',{attrs:{"sid":_vm.className()}}),_c('sid-range-slider',{attrs:{"label":"Gap","sid":_vm.className(),"rule-name":"gap","default-dimension":"px","dimensions":[]}})]},proxy:true},{key:"Hover",fn:function(){return [_c('b-form-group',{attrs:{"label":"Link Color"}},[_c('sid-color',{attrs:{"rule-name":"color","sid":_vm.className(' a:hover'),"presudo":":hover"}})],1),_c('sid-font',{attrs:{"sid":_vm.className(' a:hover'),"presudo":":hover"}})]},proxy:true},{key:"Active",fn:function(){return [_c('b-form-group',{attrs:{"label":"Link Color"}},[_c('sid-color',{attrs:{"rule-name":"color","sid":_vm.className(' a.active')}})],1),_c('sid-font',{attrs:{"sid":_vm.className(' a.active')}})]},proxy:true}])})],1),_c('SidbearSettingsGroup',{attrs:{"title":"Drop Shadow"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":"Shadow Color"}},[_c('sid-box-shadow',{attrs:{"sid":_vm.className(),"rule-name":"box-shadow"}})],1)],1),_c('SidbearSettingsGroup',{attrs:{"title":"Border & Radius"}},[_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Border Type")]),_c('sid-select',{staticClass:"w-[118px]",attrs:{"sid":_vm.className(),"rule-name":"border-style","searchable":false,"options":[{label: 'Solid', value: 'solid'}, {label: 'Dashed', value: 'dashed'}, {label: 'Dotted', value: 'dotted'}, {label: 'Double', value: 'double'}, {label: 'Outset', value: 'outset'}]}})],1)]),_c('b-form-group',[_c('sid-linked-group',{staticClass:"!mb-[7px]",attrs:{"sid":_vm.className(),"label":"Border Width","rule-name":"border","css-var":"--border-size","angles":[
          {
            text: '',
            value: 'top-width'
          },
          {
            text: '',
            value: 'right-width'
          },
          {
            text: '',
            value: 'bottom-width'
          },
          {
            text: '',
            value: 'left-width'
          }
        ]}}),_c('div',{staticClass:"flex w-full justify-end"},[_c('sid-color',{attrs:{"sid":_vm.className(),"rule-name":"border-color"}})],1)],1),_c('sid-linked-group',{attrs:{"label":"Radius","sid":_vm.className(),"rule-name":"border","titles":['top-l', 'top-r', 'bottom-l', 'bottom-r'],"angles":[
        {
          text: '',
          value: 'top-left-radius',
          cssVar: '--border-top-left-radius'
        },
        {
          text: '',
          value: 'top-right-radius',
          cssVar: '--border-top-right-radius'
        },
        {
          text: '',
          value: 'bottom-left-radius',
          cssVar: '--border-bottom-left-radius'
        },
        {
          text: '',
          value: 'bottom-right-radius',
          cssVar: '--border-bottom-right-radius'
        }
      ]}})],1),_c('SidbearSettingsGroup',{attrs:{"title":"Padding & Margins"}},[_c('sid-linked-group',{attrs:{"label":"Padding","sid":_vm.className(),"rule-name":"padding","min":0,"angles":[
        {
          text: '',
          value: 'top'
        },
        {
          text: '',
          value: 'right'
        },
        {
          text: '',
          value: 'bottom'
        },
        {
          text: '',
          value: 'left'
        }
      ]}}),_c('sid-linked-group',{staticClass:"mb-0",attrs:{"label":"Margin","sid":_vm.className(),"rule-name":"margin","min":-2000,"max":2000,"angles":[
        {
          text: '',
          value: 'top'
        },
        {
          text: '',
          value: 'right'
        },
        {
          text: '',
          value: 'bottom'
        },
        {
          text: '',
          value: 'left'
        }
      ]}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }